import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import QuickEntries from "./components/QuickEntries";
import Sources from "./components/Sources";
import Process from "./components/Process";
import Insider from "./components/Insider";
import About from "./components/About";
import Faq from "./components/Faq";
import Cooperation from "./components/Cooperation";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import { faqItems } from "@/mocks/homeContent";

function JsonLd() {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqItems.map((item) => ({
      "@type": "Question",
      name: item.q,
      acceptedAnswer: { "@type": "Answer", text: item.a },
    })),
  };

  const orgSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "曝光导航",
    url: "https://hbmdznxy.cn/",
    description:
      "汇总爆料入口与投稿渠道，提供信息来源与线索征集方式，集中呈现投稿指引、知情者通道与合作入口的信息导航平台。",
  };

  const webSiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "曝光导航",
    url: "https://hbmdznxy.cn/",
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webSiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
    </>
  );
}

export default function Home() {
  return (
    <>
      <JsonLd />
      <main className="min-h-screen w-full bg-background-50">
        <Navbar />
        <Hero />
        <QuickEntries />
        <Sources />
        <Process />
        <Insider />
        <About />
        <Cooperation />
        <Faq />
        <Contact />
        <Footer />
      </main>
    </>
  );
}